module.exports = __webpack_public_path__ + "static/images/bookmark-unfill.Gh66PCH.svg";